import React from 'react';
import AltContainer from 'alt-container';
import connectToStores from 'alt-utils/lib/connectToStores';
import OAuthStore from 'stores/OAuthStore';
import OAuthActions from 'actions/OAuthActions';
import {IntegrationCardList} from '@components/integrations/IntegrationCardList';
import RecallZoomIntegrationActions from '@store/recall/RecallZoomIntegrationActions';
import RecallZoomIntegrationStore from '@store/recall/RecallZoomIntegrationStore';
import {RecallZoomIntegrationCard} from '@components/integrations/RecallZoomIntegrationCard';

interface IntegrationCallCardListContainerProps {}

@connectToStores
export class IntegrationCardListContainer extends React.Component<
  IntegrationCallCardListContainerProps &
    ReturnType<typeof IntegrationCardListContainer.getPropsFromStores>
> {
  static getStores() {
    return [OAuthStore, RecallZoomIntegrationStore];
  }

  static getPropsFromStores() {
    const cards = OAuthStore.getState().get('oauthStatus');
    const {authURI: recallZoomAuthURI, state: recallZoomState} =
      RecallZoomIntegrationStore.getState();
    return {
      cards,
      recallZoomAuthURI,
      recallZoomState,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      OAuthActions.fetchStatus();
      RecallZoomIntegrationActions.fetchRecallZoomState();
    }, 0);
  }

  render() {
    return (
      <AltContainer>
        <RecallZoomIntegrationCard
          authURI={this.props.recallZoomAuthURI}
          state={this.props.recallZoomState}
        />
        <IntegrationCardList cards={this.props.cards} />
      </AltContainer>
    );
  }
}
